import { Link } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import { Carousel } from "ui/molecules/Carousel";
import { RecipeCard } from "@thrivetribe/mvf.ui.molecules.recipe-card";
import { RecipeType } from "types/recipes";

interface RecipeCarouselProps {
  recipes?: RecipeType[] | undefined;
}

const RecipeCarousel = ({ recipes }: RecipeCarouselProps): JSX.Element => {
  if (!recipes) {
    return <></>;
  }

  return (
    <div className="recipe-carousel">
      <Carousel heading={"Recipes"} moreText={"More recipes"} moreLink={"/recipes"} specificClass={"recipe-carousel"}>
        {recipes?.map((recipe) => (
          <SwiperSlide key={recipe.id}>
            <Link to={`/recipes/${recipe.slug}`} key={recipe.id}>
              <RecipeCard
                title={recipe.title}
                description={recipe.introduction}
                imgUrl={recipe.asset.file.url}
                imgTitle={recipe.asset.file.fileName}
                mealType={recipe.mealType[0]}
                time={`${recipe.readyIn} mins`}
                kCal={recipe.nutritionalBreakdown?.portion?.singleServing?.foodLabel.energyKcal.weight}
                onClick={() => {
                  window.scroll(0, 0);
                }}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Carousel>
    </div>
  );
};

export default RecipeCarousel;
